<template>
  <div class="kanban-layout-wrap">
    <div class="kanban-layout-wrap__scroller">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup />

<style lang="scss" scoped>
.kanban-layout-wrap {
  &__scroller {
    display: flex;
    gap: 1.25rem;
  }
}
</style>
